import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../management.css";
import { Store } from "../Store";

export default function ManagementScreen() {
  const { state } = useContext(Store);
  const { userInfo } = state;
  return (
    <div className="medium-container management-screen">
      <Row className="link-container">
        <Col md={3} className="link-item">
          <Link to="/admin/categories">
            <div className="link-box" style={{ backgroundColor: "#f0ad4e" }}>
              <i className="fas fa-th-large" style={{ fontSize: "40px" }}></i>
              <span>Kategoriler</span>
            </div>
          </Link>
        </Col>
        <Col md={3} className="link-item">
          <Link to="/admin/products">
            <div className="link-box" style={{ backgroundColor: "#5bc0de" }}>
              <i className="fas fa-box" style={{ fontSize: "40px" }}></i>
              <span>Ürünler</span>
            </div>
          </Link>
        </Col>
        <Col md={3} className="link-item">
          <Link to="/admin/users">
            <div className="link-box" style={{ backgroundColor: "#5cb85c" }}>
              <i className="fas fa-user" style={{ fontSize: "40px" }}></i>
              <span>Kullanıcılar</span>
            </div>
          </Link>
        </Col>
        <Col md={3} className="link-item">
          <Link to="/admin/compartments">
            <div className="link-box" style={{ backgroundColor: "#d9534f" }}>
              <i className="fas fa-warehouse" style={{ fontSize: "40px" }}></i>
              <span>Bölümler</span>
            </div>
          </Link>
        </Col>
        <Col md={3} className="link-item">
          <Link
            to={`/qrmenu?code=${
              userInfo?.isHelpDesk && userInfo?.client
                ? userInfo?.client?.businessOwner
                : userInfo?.membership.businessOwner
            }`}
          >
            <div className="link-box" style={{ backgroundColor: "#6f42c1" }}>
              <i className="fas fa-qrcode" style={{ fontSize: "40px" }}></i>
              <span>QR Menu</span>
            </div>
          </Link>
        </Col>
        <Col md={3} className="link-item">
          <Link to="/admin/tabletypes">
            <div className="link-box" style={{ backgroundColor: "#ff6f61" }}>
              <i className="fas fa-chair" style={{ fontSize: "40px" }}></i>
              <span>Masa Türleri</span>
            </div>
          </Link>
        </Col>
        <Col md={3} className="link-item">
          <Link to="/admin/productseed">
            <div className="link-box" style={{ backgroundColor: "#FF69B4" }}>
              <i
                className="fas fa-cloud-download-alt"
                style={{ fontSize: "40px" }}
              ></i>
              <span>Ürün Aktar</span>
            </div>
          </Link>
        </Col>
        <Col md={3} className="link-item">
          <Link to="/admin/tabletypeseed">
            <div className="link-box" style={{ backgroundColor: "#FF1493" }}>
              <i
                className="fas fa-cloud-download-alt"
                style={{ fontSize: "40px" }}
              ></i>
              <span>Masa Tipi Aktar</span>
            </div>
          </Link>
        </Col>
      </Row>
    </div>
  );
}
